import {CordovaDeviceModel} from './cordova-device.model';
import {StackFrameDetailModel} from './stack-frame-detail.model';
import StackFrame = StackTrace.StackFrame;

export class ErrorLogModel {
    public date: string;
    public url: string;
    public message: string;
    public type: string;
    public stackFrames: StackFrame[];
    public cause: string;
    public device: CordovaDeviceModel;
    public applicationName: string;
    public applicationVersion: string;
    public applicationBranch: string;
    public operator: string;
    public companyName: string;
    public companyPhone: string;

    [x: string]: any;
}
